import { Service } from "@roc/feature-app-core";

const url = {
  GET_DOCUMENT_TYPE: '/api/v1/property/documentType/getDocumentType',
  SAVE_DOCUMENT_TYPE: '/api/v1/property/documentType/saveDocumentType',
};

export class PermitService extends Service{
  getPermitsDocumentType(loanId, propertyId) {
    return this.get(url.GET_DOCUMENT_TYPE,{loanId,propertyId})
  }

  savePermitDocumentType(documentTypeData){
    return this.put(url.SAVE_DOCUMENT_TYPE,documentTypeData);
  }
}